<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/33X2Ya/tc-custom/9781626815032.jpg?1734349019236" alt="This image is the cover for the book To Hatred Turned"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">To Hatred Turned
      </h1>
      <p class="bookDescription body article font2">
        <b>“Englade (<i>Beyond Reason</i>) here treats a complex Dallas murder case with a master’s touch . . . [A] web of blackmail and hired killers” (<i>Publishers Weekly</i>).</b><br/>  <br/> Reporter Ken Englade explores the complex case of Rozanne Gailiunas, a woman in Texas who, in 1983, was the victim of a grisly, unsolved murder. Her married boyfriend, Larry Aylor, was questioned, but there wasn’t enough evidence to tie him to the crime. It looked like this murder would go unsolved.<br/>  <br/> Then, in 1988, an unexpected source tipped police off and set in motion a twisted story of family betrayal and murder-for-hire. Englade brings every shocking detail to light in unraveling this complex tale, weaving together a spellbinding narrative of a family willing to kill to get what it wants, and a trial that brought them to justice.<br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ken Englade
      </h2>
      
      <p class="authorDescription body article">Kenneth Englade is a New Mexico-based author who has published nine books dealing with high profile trials. <I>Beyond Reason</I>, his book about a University of Virginia coed and her German boyfriend who conspired to kill the woman&rsquo;s parents was a finalist for the Edgar Allan Poe Award. From 2000&ndash;2006 he was a public information officer for the Air Force and the Missile Defense Agency. In 2010 he was inducted into the Hall of Fame at the Louisiana State University School of Mass Communications.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Diversion Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?b95333a0